import { type Dispatch } from 'redux';
import { getBlogCache } from '@wix/ambassador-blog-v1-blog-cache/http';
import { createAction, type CommonThunkAction } from '@wix/communities-blog-client-common';
import { type GetState } from '../../types';
import {
  getMetaSiteId,
  getIsDemoMode,
  getSiteIsTemplate,
} from '../instance-values/instance-values-selectors';
import {
  FETCH_SITE_PROPERTIES_REQUEST,
  FETCH_SITE_PROPERTIES_SUCCESS,
  FETCH_SITE_PROPERTIES_FAILURE,
} from './site-properties-types';

const fetchSitePropertiesRequest = createAction(FETCH_SITE_PROPERTIES_REQUEST);
const fetchSitePropertiesSuccess = createAction(FETCH_SITE_PROPERTIES_SUCCESS);
const fetchSitePropertiesFailure = createAction(FETCH_SITE_PROPERTIES_FAILURE);

export const fetchSiteProperties = (): CommonThunkAction => {
  return async (dispatch: Dispatch, getState: GetState, { httpClient, errorHandler }) => {
    dispatch(fetchSitePropertiesRequest());
    const { withErrorHandler, getResolvedError } = errorHandler;

    const state = getState();
    const shouldSkipFetch =
      !getMetaSiteId(state) || getIsDemoMode(state) || getSiteIsTemplate(state);

    if (shouldSkipFetch) {
      dispatch(fetchSitePropertiesSuccess({}));
      return;
    }

    try {
      const response = await withErrorHandler(() => httpClient.request(getBlogCache({})), {
        errorCodesMap: {},
      });
      dispatch(fetchSitePropertiesSuccess(response?.data?.blogCache?.siteProperties));
    } catch (error) {
      getResolvedError(error);
      dispatch(fetchSitePropertiesFailure());
    }
  };
};
